import React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Typography, Button, Icon, Avatar } from '@ann/web-components';
import {
    ConfirmModalContent,
    ConfirmModalIcon,
    ConfirmModalText,
    ConfirmModalActions,
    DocumentsToShareItemConfirmation,
    DocumentsToShareItem,
    SelectedAgentsListToConfirmationContent,
    SelectedAgentsListToConfirmationItem
} from '../Modal.styled';

const ConfirmAssignModal = observer(({
    isOpen,
    onClose,
    onConfirm,
    documentCount = 1,
    agentCount = 1,
    pendingAgents = [],
    isLoading = false,
    itemsToAssign = []
}) => {
    const getTitle = () => {
        if (documentCount === 1 && agentCount === 1) {
            return "You’re about to add this document to this agents?";
        } else if (documentCount === 1 && agentCount > 1) {
            return `You’re about to add this document to this agents??`;
        } else if (documentCount > 1 && agentCount === 1) {
            return `You’re about to add this document to this agents??`;
        } else {
            return `You’re about to add this document to this agents?`;
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="small"
            width="900px"
        >
            <Modal.Body>
                <ConfirmModalContent>
                    <ConfirmModalText>
                        <Typography
                            category="title"
                            size="medium"
                            weight="bold"
                            color="title"
                        >
                            {getTitle()}
                        </Typography>
                    </ConfirmModalText>
                    <DocumentsToShareItemConfirmation>
                        {itemsToAssign.map((item, index) => (
                            <DocumentsToShareItem key={index}>
                                <Icon name="description" size="small" />
                                <Typography
                                    category="body"
                                    size="medium"
                                    weight="regular"
                                    color="body"
                                    maxCharacters={30}
                                >
                                    {item.name}
                                </Typography>
                            </DocumentsToShareItem>
                        ))}
                    </DocumentsToShareItemConfirmation>
                    <SelectedAgentsListToConfirmationContent>
                        {pendingAgents.map((agent, index) => (
                            <SelectedAgentsListToConfirmationItem key={index}>
                                <Avatar
                                    alt="Default avatar"
                                    size="md"
                                    src="https://via.placeholder.com/150"
                                />
                                <Typography
                                    category="body"
                                    size="medium"
                                    weight="regular"
                                    color="body"
                                >
                                    {agent.name}
                                </Typography>
                            </SelectedAgentsListToConfirmationItem>
                        ))}
                    </SelectedAgentsListToConfirmationContent>

                    <ConfirmModalActions>
                        <Button
                            label="Cancel"
                            size="medium"
                            type="secondary"
                            onClick={onClose}
                            disabled={isLoading}
                        />
                        <Button
                            label="Yes, add"
                            size="medium"
                            type="primary"
                            onClick={onConfirm}
                            disabled={isLoading}
                        />
                    </ConfirmModalActions>
                </ConfirmModalContent>
            </Modal.Body>
        </Modal>
    );
});

export default ConfirmAssignModal;

